<template>
  <modal-component
    :active="active"
    @cancel="close"
    @hdlOnClick="addContractualDocument"
    textSave="Guardar"
    titleModal="Agregar nueva página"
    :disabled="loading"
    :loader="loading"
  >
    <div class="columns is-multiline is-centered">
      <div class="column is-8">
        <div class="field">
          <label class="label">Nombre <span class="is-mandatory">*</span></label>
          <div class="control">
            <input
              class="input"
              type="text"
              placeholder="Nombre"
              v-model="name"
              name="name"
              v-validate="'required'"
              data-vv-as="nombre"
              :class="{ 'is-danger': vverrors.has('name') }"
              data-testid="field-name"
            >
            <p class="is-error">{{ vverrors.first('name') }}</p>
          </div>
        </div>
      </div>
    </div>
  </modal-component>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import mixins from '@/mixins/formats'

export default {
  components: {
    ModalComponent: () => import('@/components/ui/ModalComponent')
  },
  mixins: [mixins],
  props: {
    active: {
      type: Boolean,
      default: false
    },
    close: {
      type: Function,
      detault: () => {}
    },
    reload: {
      type: Function,
      detault: () => {}
    }
  },
  data () {
    return {
      loading: false,
      name: null
    }
  },
  computed: {
    ...mapState({
      systemConfiguration: state => state.configuration,
      profile: state => state.financialCompany.financialCompany
    })
  },
  methods: {
    ...mapActions(['createCmsPage']),
    async addContractualDocument () {
      if (await this.$validator.validateAll()) {
        this.loading = true
        const response = await this.createCmsPage({
          name: this.name
        })
        if (response.success) {
          await this.reload()
          this.close()
        }
      }
      this.loading = false
    }
  }
}
</script>
